import '../sass/image.scss';

(() => {
    const $imageBlocks = document.querySelectorAll('.image');

    if (!$imageBlocks) return;

    $imageBlocks.forEach($imageBlock => {
        const $image = $imageBlock.querySelector('img');

        const initParallax = () => {
            if (!$imageBlock.classList.contains('image--has-parallax')) return;

            const movement = window.innerWidth / 10;
            
            let scrollFraction = (-1 * ($imageBlock.getBoundingClientRect().top - window.innerHeight)) / ($image.clientHeight + window.innerHeight);

            if ($imageBlock.classList.contains('image--hide-overflow')) {
                if (scrollFraction > 1) scrollFraction = 1;
                if (scrollFraction < 0) scrollFraction = 0;

                $image.style.marginTop = `-${movement}px`;
                $image.style.marginBottom = `-${movement}px`;
            }

            $image.style.transform = `translateY(${- movement +(movement * 2) * scrollFraction}px)`;
        };

        window.addEventListener('scroll', initParallax);
        window.addEventListener('resize', initParallax);

        initParallax();
    });
})();
